// Redux/Slices/profileSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { setStatusFail } from './statusFailSlice';

const initialState = {
  profileData: null,
  locationProfiles: null,
  loading: false,
  error: null,
  }
  const ACCOUNTS_URL  = process.env.REACT_APP_ACCOUNTS_URL
const ADMIN_URL =  process.env.REACT_APP_ADMIN_URL


// Async thunk for fetching user profile
export const fetchUserProfile = createAsyncThunk(
  'profile/fetchUserProfile',
  async ({ userId, accessToken, tenantId,navigate }, {rejectWithValue,dispatch}) => {
    Cookies.set("Token",accessToken);
    Cookies.set("UserId",userId);
    Cookies.set("TenantId", tenantId);
    try {
      const response = await axios.get(`${ACCOUNTS_URL}/profiles/user-profile/${userId}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
            usertype: "practitioner",
          tenantId
          },
      });
      Cookies.set("Token", response.data.data.access_token);
      Cookies.set("TenantId", tenantId);
      Cookies.set("UserId", userId);

      localStorage.setItem(
        "admin_profile",
        JSON.stringify(response.data.data.profile)
      );
      return response.data.data.profile;
    } catch (error) {
    let message=  error?.response?.data?.error?.message || "Something went wrong"
      let route=  "/unauthorized"

      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }else if (!error.response || error.response.status >= 500) {
        // Network blip or server error: keep the session and let the user retry instead of logging them out.
        toast.error("The service is temporarily unavailable. Please refresh in a moment.");
      }else{
        navigate(route)
      }
      
      return rejectWithValue(message);
    }
  }
);


export const fetchLocationProfiles = createAsyncThunk(
  'profile/fetchLocationProfiles',
  async ({ tenantId, locationId, userType, accessToken }, { rejectWithValue, dispatch }) => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
        tenantid: tenantId,
        locationid: locationId,
      };

      if (userType) {
        headers.usertype = userType;
      }

      const response = await axios.get(`${ACCOUNTS_URL}/profiles/location-profile`, { headers });

      Cookies.set('TenantId', tenantId);
      Cookies.set('LocationId', locationId);
      if (userType) {
        Cookies.set('UserType', userType);
      }

      localStorage.setItem('location_profiles', JSON.stringify(response.data.data));
      return response.data.data;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response?.data?.error?.message || 'Something went wrong');
    }
  }
);

export const updateLastApp =
  ({ userId, body }) =>
  async () => {
    try {
      const response = await axios.patch(
        `${ACCOUNTS_URL}/lastapp/${userId}`,
        body
      );
      return response;
    } catch (error) {
      return error.response;
    }
  };

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    updateUserProfileImage:(state,action)=>{
      state.profileData.imageUrl = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.profileData = action.payload;
        state.loading = false;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchLocationProfiles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLocationProfiles.fulfilled, (state, action) => {
        state.locationProfiles = action.payload;
        state.loading = false;
      })
      .addCase(fetchLocationProfiles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {updateUserProfileImage} = profileSlice.actions
export default profileSlice.reducer;
